import { DESKTOP_COLUMN_WIDTH, SPAN_HEIGHT } from './helpers'

type ImageDimensions = {
  width: number | undefined
  height: number | undefined
}

type UseMasonryParams = {
  imageDimensions: ImageDimensions
  aspectRatio: number
  infoSpanCount: number
}

type UseMasonryResponseType = {
  totalSpanCount: number
}

const useMasonry = ({
  imageDimensions,
  aspectRatio,
  infoSpanCount,
}: UseMasonryParams): UseMasonryResponseType => {
  const columnWidth = imageDimensions?.width || DESKTOP_COLUMN_WIDTH
  const imageHeight =
    imageDimensions?.height || parseInt((columnWidth / aspectRatio).toString(), 10)
  const imageSpanCount = Math.ceil(imageHeight / SPAN_HEIGHT)
  const totalSpanCount = imageSpanCount + infoSpanCount

  return { totalSpanCount }
}

export default useMasonry
